import {combineReducers} from 'redux';
import authenticationReducer from "./authentication/authenticationReducer";
import menuReducer from "./menu/menuReducer";
import topBarReducer  from "./menu/topBarReducer";
import topRailNavReducer  from "./nav/topRailNavReducer";
import platformUserReducer  from "./user/platformUserReducer";
import assignmentsReducer from "./assignments/assignmentsReducer";
import productsReducer from './products/productsReducer';

const rootReducer = combineReducers( {
    authentication: authenticationReducer,
    menu: menuReducer,
    topBar: topBarReducer,
    topRailNav: topRailNavReducer,
    platformUser: platformUserReducer,
    assignments: assignmentsReducer,
    products: productsReducer
});

export default rootReducer;
